import * as React from 'react';

import styles from './VerificationError.module.scss';
import { MdError } from 'react-icons/md';
//tr
import { tr } from '../../utils/translations/translator';
import { useTranslation } from 'react-i18next';
export interface VerificationErrorProps {}

export const VerificationError: React.FC<VerificationErrorProps> = (props) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <h1> {tr(t, 'acc-verification_error')}</h1>
      <MdError size={60} />
    </div>
  );
};
